var map = {
	"./de.json": "3389",
	"./en.json": "90f9",
	"./et.json": "d3b2",
	"./fr.json": "efe3",
	"./ja.json": "4e91",
	"./lv.json": "8b3c",
	"./ru.json": "3472"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf50";